<template>
  <div class="card card-custom gutter-b card-stretch">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <div class="card-title text-left">
        <div class="card-label font-weight-bolder text-dark-75">
          {{ $t("messages.dashboard.risk.title") }}
          <div class="font-size-sm text-muted mt-2">
            {{ $t("messages.dashboard.risk.subtitle") }}
          </div>
        </div>
      </div>
      <div class="card-toolbar"></div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body d-flex flex-column">
      <div class="row">
        <!--begin::Chart-->
        <apexchart
          class="col-md-8 pr-3"
          type="line"
          height="250"
          :options="lineOptions"
          :series="lineSeries"
        />
        <div class="col-md-4 pl-10">
          <VueSvgGauge
            class="pb-10"
            :start-angle="-110"
            :end-angle="110"
            :value="this.score"
            :separator-step="1"
            :min="0"
            :max="10"
            :gauge-color="[
              {
                offset: 0,
                color: getColorByValueAndBase(
                  this.score - 2 > 0 ? this.score - 2 : 0,
                  10,
                  true
                )
              },
              {
                offset: 100,
                color: getColorByValueAndBase(this.score, 10, true)
              }
            ]"
            :scale-interval="1"
          >
            <div class="inner-text inner-text--1">
              <span v-if="score >= 0">
                {{ $n(score.toFixed(1)) }}
              </span>
              <span v-else>?</span>
              <span class="small">/10</span>
              <div class="inner-title">
                <span>{{ $t("messages.dashboard.status.score") }}</span>
              </div>
            </div>
          </VueSvgGauge>
        </div>
        <!--end::Chart-->
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import moment from "moment-timezone";
import _ from "lodash";
import { getColorByValueAndBase } from "@/utils/helpers";
import { VueSvgGauge } from "vue-svg-gauge";

export default {
  name: "AvgMaxRisk",
  components: {
    VueSvgGauge
  },
  props: {
    score: {
      required: true
    },
    evolution: {
      required: false,
      type: Array
    },
    discrete: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      cols: [
        {
          type: "score",
          title: this.$t("messages.dashboard.status.score"),
          value: this.score || -1,
          base: 10,
          class: "score",
          color: getColorByValueAndBase(this.score, 10, true)
        }
      ]
    };
  },
  computed: {
    lineSeries() {
      return [
        {
          name: this.$t("messages.dashboard.risk.average"),
          type: "line",
          data: _.map(this.evolution, "value")
        }
      ];
    },
    colorStops() {
      var steps = this.evolution.length / 100;
      var result = [];
      for (var i = 0; i < this.evolution.length; i++) {
        result.push({
          offset: i * steps,
          color:
            getColorByValueAndBase(this.lineSeries[0].data[i], 10, true) + "9a",
          opacity: 0.8
        });
      }
      return result;
    },
    lineOptions() {
      return {
        chart: {
          height: 300,
          type: "line",
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: false,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: false,
              customIcons: []
            }
          }
        },
        stroke: {
          lineCap: "round",
          width: 5,
          curve: "smooth"
        },
        legend: {
          show: false
        },
        xaxis: {
          type: "datetime",
          categories: _.map(this.evolution, point => {
            return moment(point.date).isValid()
              ? moment(point.date, "YYYY-MM-DD hh:mm:ss").format()
              : "";
          }),
          tickAmount: this.evolution.length
        },
        fill: {
          type: "gradient",
          gradient: {
            type: "horizontal",
            opacityFrom: 1,
            opacityTo: 1,
            colorStops: this.colorStops
          }
        },
        yaxis: {
          min: 0,
          max: 10,
          tickAmount: 10,
          labels: {
            formatter: value => this.$n(value, { maximumFractionDigits: 1 })
          }
        },
        grid: {
          show: false
        },
        markers: {
          discrete: this.discrete
        }
      };
    }
  },
  methods: {
    getColorByValueAndBase(value, base, hex) {
      return getColorByValueAndBase(value, base, hex) + "aa";
    }
  }
};
</script>

<style lang="scss">
.apexcharts-legend.position-left {
  text-align: left;
}
.inner-text {
  &--1 {
    padding-top: 34%;
    text-align: center;
    font-size: 2.5rem;
    font-weight: bold;
    width: 100%;
    height: 100%;
    .small {
      font-size: 1rem;
      top: 2rem;
    }
  }
  .inner-title {
    width: 100%;
    text-align: center;
    font-size: 0.75rem;
  }
}
</style>
